import React, { Component } from 'react'

import { Header } from 'semantic-ui-react'
import invariant from 'invariant'

import Permissions from 'Components/Permissions'

const withPermissions = permissions => WrappedComponent => {
  invariant(!!permissions, 'You have to set permissions.')

  class WithPermissions extends Component {
    state = {
      isMounted: false,
      shouldDisplayError: false,
      timeout: null,
    }

    componentDidMount() {
      this.setState({ isMounted: true })
      this.setState({ timeout: setTimeout(this.displayError, 500) })
    }

    componentWillUnmount() {
      const { timeout } = this.state

      if (timeout) {
        clearTimeout(timeout)
      }
    }

    displayError = () => {
      const { isMounted } = this.state

      if (isMounted) {
        this.setState({ shouldDisplayError: true, timeout: null })
      }
    }

    render() {
      const { shouldDisplayError } = this.state

      return (
        <Permissions
          permissions={permissions}
          render={() => <WrappedComponent {...this.props} />}
          renderElse={() => shouldDisplayError && <Header>Not Allowed</Header>}
        />
      )
    }
  }

  return WithPermissions
}

export default withPermissions
